<template>
    <div>
        <span
            v-html="$t('notification.reservationDeleted',{ name: $_.get(activity,'payload.userName'), visitor: maskedVisitorName, date: $_.get(activity, 'payload.date')})"></span>
    </div>
</template>
<script>
import _ from "lodash";
import activityVisitorMaskMixin from "./activityVisitorMaskMixin";

export default {
    name: "ReservationDeleted",
    mixins: [activityVisitorMaskMixin],
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        maskedVisitorName() {
            return this.maskVisitorDisplayName(_.get(this.activity, "payload.visitorName"));
        },
    },
};
</script>
<style></style>
